//
// 書類の更新提出（P12）
// 期限接近書類ごとにカメラ／ファイル選択 → プレビュー → 提出
//
const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'pdf']
const MAX_FILE_SIZE = 10 * 1024 * 1024

export default {
  name: 'document-renewal-list',
  created () {
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      items: []
    }
  },
  computed: {
    targets () {
      return this.$store.getters.documentRenewalTargets
    }
  },
  methods: {
    search: function () {
      var self = this
      var callback = function () {
        self.buildItems()
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('GET_DOCUMENT_RENEWAL_TARGETS', {callback: callback})
    },
    // API の結果から画面用の状態を組み立てる
    buildItems: function () {
      var targets = this.targets || []
      var items = []
      for (var i = 0; i < targets.length; i++) {
        var attrs = targets[i].attributes
        items.push({
          documentType: attrs['document-type'],
          documentTypeName: attrs['document-type-i18n'],
          deadlineDate: attrs['target-deadline-date-format'],
          renewal: attrs['renewal'],
          file: null,
          previewSrc: null,
          submitting: false,
          error: null
        })
      }
      this.items = items
    },
    // 行（書類種別）ごとの file input（v-for 内の ref は配列になるため、添字ではなく書類種別で引く。入社手続き画面と同じ方式。No6）
    fileInputFor: function (prefix, documentType) {
      var refs = this.$refs[prefix + '_' + documentType]
      if (!refs) {
        return null
      }
      return Array.isArray(refs) ? refs[0] : refs
    },
    // 撮影用 input（capture="environment"、multiple なし）。選択後に同じファイルを選び直せるよう value を空にする
    openCamera: function (item) {
      var input = this.fileInputFor('cameraInput', item.documentType)
      if (input) {
        input.value = ''
        input.click()
      }
    },
    // ファイル選択用 input（capture なし）
    openFile: function (item) {
      var input = this.fileInputFor('fileInput', item.documentType)
      if (input) {
        input.value = ''
        input.click()
      }
    },
    onFileChange: function (index, event) {
      var files = event.target.files || event.dataTransfer.files
      if (!files || files.length === 0) {
        return
      }
      var file = files[0]
      var item = this.items[index]
      item.error = null

      var extension = (file.name || '').split('.').pop().toLowerCase()
      if (ALLOWED_EXTENSIONS.indexOf(extension) < 0) {
        item.file = null
        item.previewSrc = null
        item.error = 'jpg / jpeg / png / pdf のファイルを選択してください。'
        return
      }
      if (file.size > MAX_FILE_SIZE) {
        item.file = null
        item.previewSrc = null
        item.error = 'ファイルサイズは10MB以内にしてください。'
        return
      }

      item.file = file
      item.previewSrc = null
      if (extension !== 'pdf') {
        var reader = new FileReader()
        reader.onload = (e) => {
          item.previewSrc = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    submit: function (index) {
      var item = this.items[index]
      if (!item.file || item.submitting) {
        return
      }
      if (!window.confirm(item.documentTypeName + 'を提出します。よろしいですか？')) {
        return
      }
      var self = this
      item.submitting = true
      item.error = null

      var formData = new FormData()
      formData.append('document_type', item.documentType)
      formData.append('file', item.file)

      var callback = function () {
        window.alert('提出しました。店舗管理者・事務員の確認をお待ちください。')
        self.search()
      }
      var errorCallback = function (message) {
        item.submitting = false
        item.error = message || '提出に失敗しました。'
      }
      this.$store.dispatch('CREATE_DOCUMENT_RENEWAL', {data: formData, callback: callback, errorCallback: errorCallback})
    },
    goTop: function () {
      this.$router.push({ path: '/' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/document-renewal-list.js